import JoinWaitList from './JoinWaitList';

export default JoinWaitList;
